const Enumeration = window['Enumeration'];

export const DayOfTheWeekEnum = Enumeration('DayOfTheWeekEnum', {
  SU: {
    microname: 'Su',
    shortname: 'Sun',
    longname: 'Sunday',
    ordinal: 1
  },
  MO: {
    microname: 'M',
    shortname: 'Mon',
    longname: 'Monday',
    ordinal: 2
  },
  TU: {
    microname: 'Tu',
    shortname: 'Tue',
    longname: 'Tuesday',
    ordinal: 3
  },
  WE: {
    microname: 'W',
    shortname: 'Wed',
    longname: 'Wednesday',
    ordinal: 4
  },
  TH: {
    microname: 'Th',
    shortname: 'Thu',
    longname: 'Thursday',
    ordinal: 5
  },
  FR: {
    microname: 'F',
    shortname: 'Fri',
    longname: 'Friday',
    ordinal: 6
  },
  SA: {
    microname: 'Sa',
    shortname: 'Sat',
    longname: 'Saturday',
    ordinal: 7
  },
  ONLINE: {
    microname: 'O',
    shortname: 'On',
    longname: 'Online',
    ordinal: 8
  }
});



// WEBPACK FOOTER //
// ./app/vendor/utility-js-time/src/enums/day_of_the_week_enum.ts